module.exports = "pegasus_template/assets/tech/sale/101.png";